// Test IDs for the Coachly landing page.

export const LANDING = {
  // Nav
  navLogo: 'landing-nav-logo',
  navFindCoach: 'landing-nav-find-coach',
  navBecomeCoach: 'landing-nav-become-coach',

  // Hero
  heroHeadline: 'landing-hero-headline',
  heroFindCoach: 'landing-hero-find-coach',
  heroBecomeCoach: 'landing-hero-become-coach',

  // Categories (5-up)
  categories: 'landing-categories',
  categoryCard: (slug) => `landing-category-${slug}`,

  // Benefits (3-up)
  benefits: 'landing-benefits',
  benefitItem: (i) => `landing-benefit-${i}`,

  // FAQ
  faq: 'landing-faq',
  faqItem: (i) => `landing-faq-item-${i}`,

  // Footer
  footer: 'landing-footer',
};
